
import store from '../store'
import router from '../router'

export const custom_columns_calculations = {
	data() {
	    return {
	    	calculationcolumn:null,	    	
    		remote_requests:[],
    		calculation_column_nodes:[],
    		calculation_column_connections:[],
	    };
	  },
	methods:{
		async resolveData(column)
		{
			this.calculationcolumn = column
	  		let output = null
	  		let calculation = JSON.parse(this.calculationcolumn.calculation)  		
	  		////////console.log(calculation)
	  		let calculation_column_nodes = calculation.nodes
	  		let calculation_column_connections = calculation.connections
	  		let equation = calculation_column_nodes.find((item)=>{return item.type=="equation"})
	  		if(equation)
	  		{
	  			let equation_connection = calculation_column_connections.find((item)=>{return item.to == equation.id})
		  		if(equation_connection)
		  		{
		  			let last_operation = calculation_column_nodes.find((item)=>{return item.id == equation_connection.from})
		  			output = await this.getOperatorNodeOutput(last_operation,calculation_column_nodes,calculation_column_connections)
		  			
		  		}
	  		}
	  		
	  		return await output
		},
		async getOperatorNodeOutput(operator,calculation_column_nodes,calculation_column_connections)
	  	{
	  		let node_input_1 = operator.input1
	  		let node_input_2 = operator.input2
	  		let node_input_1_value 
	  		let node_input_2_value 
	  		let output = null
	  		//get input 1 value
	  		if(node_input_1)
	  		{
	  			if(node_input_1.type=="value")
	  			{
	  				node_input_1_value = node_input_1.value
	  			}
	  			if(node_input_1.type=="connection")
	  			{
	  				//console.log("FIND CONNECTION 1")
	  				//console.log(node_input_1)
	  				let connection = calculation_column_connections.find((item)=>{return item.id == node_input_1.connection_id})
	  				//console.log(connection)
	  				let input_node = calculation_column_nodes.find((item)=>{return item.id == connection.from})
	  				node_input_1_value = await this.getNodeOutput(input_node,calculation_column_nodes,calculation_column_connections)
	  			}

	  		}
	  		//get input 1 value


	  		//get input 2 value
	  		if(node_input_2)
	  		{
	  			if(node_input_2.type=="value")
	  			{
	  				node_input_2_value = node_input_2.value
	  			}
	  			if(node_input_2.type=="connection")
	  			{
	  				//console.log("FIND CONNECTION 2")
	  				//console.log(node_input_2.connection_id)
	  				//console.log(calculation_column_connections)
	  				let connection = calculation_column_connections.find((item)=>{return item.id == node_input_2.connection_id})	  				
	  				//console.log(connection)
	  				let input_node = calculation_column_nodes.find((item)=>{return item.id == connection.from})
	  				node_input_2_value = await this.getNodeOutput(input_node,calculation_column_nodes,calculation_column_connections)  				
	  			}
	  		}
	  		//get input 2 value
	  		
	  		if(operator.type=="addition" || operator.type=="subtraction")
	  		{
	  			if(this.calculationcolumn.calculate_with_zero)
	  			{
	  				if(!node_input_1_value || isNaN(node_input_1_value))
		  			{
		  				node_input_1_value = 0
		  			}
		  			if(!node_input_2_value || isNaN(node_input_2_value))
		  			{
		  				node_input_2_value = 0
		  			}
	  			}
	  			else
	  			{
	  				if(!node_input_1_value && node_input_1_value!==0)
	  				{
	  					////console.log("hit")
	  					output = null
	  					return
	  				}
	  				if(!node_input_2_value && node_input_2_value!==0)
	  				{
	  					output = null
	  					return
	  				}
	  			}

	  		}
	  		if(operator.type=="addition")
	  		{	  			
	  			output = node_input_1_value+node_input_2_value  			
	  		}

	  		if(operator.type=="subtraction")
	  		{  			
	  			output = node_input_1_value-node_input_2_value
	  		}

	  		if(operator.type=="multiplication")
	  		{
	  			
	  			if(!node_input_1_value || node_input_1_value!==0)
	  			{  				
	  				
	  			}
	  			else
	  			{
	  				if(this.calculationcolumn.calculate_with_zero)
	  				{
	  					node_input_1_value = 1
	  				}
	  				else
	  				{
	  					//node_input_1_value = 0
	  				}
	  			}

	  			if(!node_input_2_value || node_input_2_value!==0)
	  			{  				
	  				
	  			}
	  			else
	  			{
	  				if(this.calculationcolumn.calculate_with_zero)
	  				{
	  					node_input_2_value = 1
	  				}
	  				else
	  				{
	  					//node_input_2_value = 0
	  				}

	  			}
	  			
	  			output = node_input_1_value*node_input_2_value
	  		}

	  		if(operator.type=="division")
	  		{
	  			if(!node_input_1_value || node_input_1_value!==0)
	  			{
	  				
	  			}
	  			else
	  			{
	  				if(this.calculationcolumn.calculate_with_zero)
	  				{
	  					node_input_1_value = 1
	  				}
	  				else
	  				{
	  					//node_input_1_value = 0
	  				}
	  			}

	  			if(!node_input_2_value || node_input_2_value!==0)
	  			{
	  				
	  			}
	  			else
	  			{
	  				if(this.calculationcolumn.calculate_with_zero)
	  				{
	  					node_input_2_value = 1
	  				}
	  				else
	  				{
	  					//node_input_2_value = 0
	  				}
	  			}
	  			
	  			output = node_input_1_value/node_input_2_value
	  		}

	  		return await output
	  	},
	  	addToCalculateStack(inputfield_id,supplier_id,period_id,flow_type,flowsupplier_id)
	  	{
	  		let id = this.generateId()
	  		let item = {
	  			id:id,
	  			inputfield_id:inputfield_id,
	  			supplier_id:supplier_id,
	  			period_id:period_id,
	  			flow_type:flow_type,
	  			flowsupplier_id:flowsupplier_id,
	  		}
	  		let arr = store.state.evaluation.calculated_fields
	  		arr.push(item)
	  		store.dispatch('evaluation/setCalculatedFields',arr) 
	  	},
	  	async remoteRequestOutputData(input_node)
	  	{
	  		let inputfield_submission
	  		let data_required_ind = this.remote_requests.findIndex(item=>item.id ==input_node.id)
			if(data_required_ind==-1)
			{
				inputfield_submission = await  this.silentApiGet("get_inputfield_submission_by_period/"+input_node.inputfield_id+"/"+store.state.evaluation.evaluation.supplier_id+"/"+input_node.period_id+"/"+store.state.evaluation.evaluation.flow.type+"/"+store.state.evaluation.evaluation.id)

				let node_obj = {
					id:input_node.id,
					inputfield_submission:inputfield_submission
				}
				this.remote_requests.push(node_obj)
			}
			else
			{
				inputfield_submission = this.remote_requests[data_required_ind].inputfield_submission
			}
			return inputfield_submission
	  	},
	  	async getNodeOutput(input_node,calculation_column_nodes,calculation_column_connections)
	  	{
	  		let output = null
	  		if(input_node.type=="variable")
	  		{
	  			let inputfield_submission
	  			let ind = store.state.evaluation.inputfields.findIndex((item)=>item.id == input_node.inputfield_id)
	  			//not in inputfieldslist
	  			if(ind==-1)
	  			{
	  				inputfield_submission = await this.remoteRequestOutputData(input_node)
	  			}
	  			//not in inputfieldslist
	  			//in inputfieldslist
	  			else
	  			{  		
	  				if(input_node.period_id !== store.state.evaluation.evaluation.projectperiod_id)
	  				{
	  					inputfield_submission = await this.remoteRequestOutputData(input_node)
	  				}
	  				else
	  				{
	  					let local_inputfield = store.state.evaluation.inputfields[ind]
		  				if(local_inputfield.submissions.length)
		  				{
		  					inputfield_submission = local_inputfield.submissions[0]
		  					inputfield_submission.inputfield = store.state.evaluation.inputfields[ind]
		  					if(inputfield_submission.is_nulled)
		  					{
		  						let the_null_reason = store.state.evaluation.nullreasons.findIndex((item)=>item.id == inputfield_submission.null_reason)
		  						if(the_null_reason ==-1)
		  						{
		  							inputfield_submission.nullreason = null
		  						}
		  						else
		  						{
		  							inputfield_submission.nullreason = store.state.evaluation.nullreasons[the_null_reason]
		  						}
		  					}  					
		  				}
	  				}
	  				
	  			}
	  			//in inputfieldslist


	  			
	  			////////console.log(inputfield_submission)
	  			
	  			
	  			
	  			
	  			
	  			if(inputfield_submission && inputfield_submission.inputfield.type=="columns")
	  			{
	  				////////console.log("inputfield_submission")
	  				////////console.log(inputfield_submission)
	  				if(inputfield_submission.submission_text)
	  				{
	  					let columns_data = JSON.parse(inputfield_submission.submission_text) 
			  			//////console.log(columns_data)
			  			//////console.log(input_node)
		  				let the_column = columns_data.find((item)=>{return item.id == input_node.column_id})
		  				//////console.log(the_column)
		  				if(!the_column)
		  				{
		  					output = null
		  					return 
		  				}
		  				//////console.log(inputfield_submission)
		  				let actual_column = inputfield_submission.inputfield.columns.find(item => item.id == the_column.id)
		  				//////console.log(actual_column)
		  				if(the_column)
		  				{
		  					
		  					//get data from custom column
		  					if(actual_column.type=="custom")
		  					{
		  						output = await this.resolveData(actual_column)	
		  						return await output
		  						//let next_column = inputfield_submission.inputfield.columns.find(item => item.id == the_column.id)
		  					}
		  					//get data from custom column
		  					//get data from value column
		  					else
		  					{
		  						if(the_column.value || the_column.value ===0)
			  					{
			  						
			  						if(!inputfield_submission.is_nulled)
				  					{
				  						
				  							
				  							if(actual_column.type=="select")
				  							{
				  								
				  								let actual_option = actual_column.options.find(item =>item.id == the_column.value)
				  								////console.log("actual_option")
				  								////console.log(actual_option)
				  								output = parseFloat(actual_option.points)
				  							}
				  							else
				  							{
				  								output = the_column.value
				  							}
				  					}
				  					else
				  					{
				  						if(inputfield_submission.nullreason && inputfield_submission.nullreason.full_points_selected)
				  						{		  							
				  							if(actual_column.type=="select")
				  							{
				  								
				  								let actual_option = actual_column.options.find(item =>item.id == the_column.value)
				  								output = parseFloat(actual_option.name)
				  							}
				  							else
				  							{
				  								output = the_column.value
				  							}
				  									  							
				  						}
				  					}
			  					}
		  					}
		  					//get data from value column 
		  				}
	  				}
	  			}

	  			if(inputfield_submission && inputfield_submission.inputfield.type=="number")
	  			{
	  				if(inputfield_submission.submission_numerical)
		  				{
		  					output = inputfield_submission.submission_numerical
		  				}
	  			}


	  			if(inputfield_submission)
		  		{
		  			
		  		}
	  			
	  		}

	  		if(input_node.type!=="variable")
	  		{
	  			output = await this.getOperatorNodeOutput(input_node,calculation_column_nodes,calculation_column_connections)
	  		}
	  		
	  		return await output
	  	},
	}
}